import React from "react";
import { Link } from "react-router-dom";
import { MONEY_STRONG_PLAN_NAME } from "./moneyPlanCopy";
import "./Delete_app.css";

function DeleteApp() {
  return (
    <div className="MoneyDelete">
      <div className="MoneyDelete-body">
        <h1>ととのう固定費のアプリ削除／アカウント削除について</h1>

        <h2>結論（大事なポイント）</h2>
        <p>
          <strong>端末からアプリを削除</strong>すると、端末内のアプリは消えます。
          <br />
          ただし、本アプリはログイン後に固定費データをクラウド（Supabase）上に保存する場合があります。
          <br />
          そのため、<strong>アプリ削除だけではクラウド上のデータが残る場合があります</strong>。
          データも削除したい場合は、下記の「アカウント削除」を実行してください。
          <br />
          {MONEY_STRONG_PLAN_NAME}（サブスクリプション）の解約は別手続きです。アカウント削除だけでは課金は止まりません。
          <Link to="/money/withdrawal"> サブスクリプションの解約について</Link>
          もあわせてご確認ください。
        </p>

        <h2>1. アプリ削除（端末から消す）</h2>
        <p>iPhone のホーム画面で本アプリのアイコンを長押しし、「Appを削除」から削除してください。</p>

        <h2>2. アカウント削除（クラウド上のデータ削除）</h2>
        <p>
          本アプリ内の「アカウント」画面からアカウント削除を実行できます。
          確認画面で注意事項に同意のうえ削除を実行すると、認証情報およびクラウド上に保存された固定費データの削除が行われます。
        </p>

        <h2>3. サブスクリプションの解約</h2>
        <p>
          お金に強くなるプランをご利用中の場合は、iPhone の「設定」→「Apple ID」→「サブスクリプション」から「ととのう固定費」のサブスクリプションを解約してください。
          詳細は <Link to="/money/withdrawal">サブスクリプションの解約について</Link> をご覧ください。
        </p>

        <h2>4. うまく削除できない場合</h2>
        <p>
          アプリにログインできない等の理由でアカウント削除を実行できない場合は、以下へご連絡ください。
          <br />
          メール：haruki2021promoter@gmail.com
        </p>

        <p style={{ marginTop: 18, opacity: 0.85 }}>※ 本ページの内容は、必要に応じて更新されます。</p>
      </div>
    </div>
  );
}

export default DeleteApp;
